import { Injectable } from '@angular/core';
//import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
 
 

@Injectable()
export class Workexpservice {

  constructor(private http: HttpClient, private _http: HttpClient) { }
  
	// workexpConfigStore( formJSON2 : any, PID: any, AID: any, WorkExpId : any,DynamicRow:any){
	// 	let formJSON1 = "";
	// 	let totexp = "";
	// 	if(DynamicRow ==1) {
	// 		formJSON1 = JSON.stringify(formJSON2.dynworkexp);
	// 		totexp = formJSON2.dyntotexp;
	// 	}else{
	// 		formJSON1 = JSON.stringify(formJSON2.workexp);
	// 		totexp = formJSON2.totexp;
	// 	}
	// 	let PID1 = JSON.stringify(PID);
	// 	let AID1 = JSON.stringify(AID);
	// 	return this._http.post(environment.appUrl + "ruleengine/workexpSubmit", { formJSON: formJSON1, PID: PID1 ,AID: AID1, WorkExpId:WorkExpId,totexp:totexp,DynamicRow:DynamicRow})
	// 	.map(result => {			
	// 		return result;
	// 	});
	// }
	
	workexpConfigStore( formJSON2 : any, PID: any, AID: any, WorkExpId : any,DynamicRow:any){
		let formJSON1 = "";

		let totexp = "";
		if(DynamicRow ==1) {
			formJSON1 = JSON.stringify(formJSON2.dynworkexp);
			totexp = formJSON2.dyntotexp;
		}else if(DynamicRow ==2){
			formJSON1 = JSON.stringify(formJSON2.workexpArmedContainer);
			totexp = formJSON2.totexparmed;
		}else{
			formJSON1 = JSON.stringify(formJSON2.workexp);
			totexp = formJSON2.totexp;
		}
		
		console.log("formJSON2 ---->",formJSON2);
		let PID1 = JSON.stringify(PID);
		let AID1 = JSON.stringify(AID);
		return this._http.post(environment.appUrl + "ruleengine/workexpSubmit", { formJSON: formJSON1, PID: PID1 ,AID: AID1, WorkExpId:WorkExpId,totexp:totexp,DynamicRow:DynamicRow})
		.map(result => {			
			return result;
		});
	}
	workexpConfigEdit( PID: any, AID: any,DynamicRow:any){
		
		let PID1 = JSON.stringify(PID);
		let AID1 = JSON.stringify(AID);
		return this._http.get(environment.appUrl + "ruleengine/workexpDetSubmit",{params:{PID:PID1,AID: AID1,DynamicRow:DynamicRow}})
		.map(result=>{
				return result;
		}); 
	}
	 
}
